import { AudiosConfig } from '@/scenarios/legacy-player/components/Player';

import { Track, JoinDataLeft, JoinDataRight } from '../Tracks.types';

export const useLeftJoinAudioTracks = (
    // eslint-disable-next-line default-param-last
    tracksFromPlayer: readonly Track[] = [],
    tracksFromStreams?: AudiosConfig
) =>
    useLeftJoin(
        { data: tracksFromPlayer, getKey: (track) => track.lang },
        { data: tracksFromStreams, getKey: (track) => track.language }
    );

export function useLeftJoin<T2, T1 extends { info?: T2 }>(
    dataLeft: JoinDataLeft<T1>,
    dataRight: JoinDataRight<T2>
): Map<string, T1> {
    const map = new Map<string, T1>();

    dataLeft.data.forEach((trackLeft) => map.set(dataLeft.getKey(trackLeft), trackLeft));

    if (dataRight.data) {
        dataRight.data.forEach((trackRight) => {
            if (map.has(dataRight.getKey(trackRight))) {
                map.set(dataRight.getKey(trackRight), {
                    ...map.get(dataRight.getKey(trackRight))!,
                    info: trackRight,
                });
            }
        });
    }

    return map;
}
